import { TextLabel } from '@core/components/Inputs';
import { formatTELEFONE } from '@format';
import { Grid } from '@material-ui/core';
import React from 'react';
import EmailAdicionalVisualizar from './EmailAdicionalVisualizar';
import TelefoneAdicionalVisualizar from './TelefoneAdicionalVisualizar';

const Contato = (props) => {
  const { contato, index } = props;

  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextLabel
          id={`pessoa.contatos[${index}].nomeReferencia`}
          value={contato.nomeReferencia}
          label="Nome do contato"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel
            id={`pessoa.contatos[${index}].numero`}
            value={contato.codigoPais ? `${contato.codigoPais} ${contato.numero}` : contato.numero}
            label="Telefone principal"
            format={formatTELEFONE}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TelefoneAdicionalVisualizar contatoIndex={index} telefonesAdicionais={contato.telefonesAdicionais} />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel id={`pessoa.contatos[${index}].email`} label="E-mail principal" value={contato.email} />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <EmailAdicionalVisualizar contatoIndex={index} emailsAdicionais={contato.emailsAdicionais} />
        </Grid>
      </Grid>
    </>
  );
};

const DadosContatoVisualizar = ({ registro }) => {
  const { pessoa = {} } = registro;
  const { contatos = [{}] } = pessoa;

  return (
    <Grid container spacing={3}>
      {contatos.map((contato, index) => {
        return <Contato key={index} index={index} contato={contato} />;
      })}
    </Grid>
  );
};

export default DadosContatoVisualizar;
